import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { TriangleAlert } from 'lucide-react';

interface ConfirmDeleteTalentDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  type: 'talent' | 'kategori';
  itemName: string;
  kategoriNavn?: string;
  childCount?: number;
}

const ConfirmDeleteTalentDialog: React.FC<ConfirmDeleteTalentDialogProps> = ({
  open,
  onClose,
  onConfirm,
  type,
  itemName,
  kategoriNavn,
  childCount = 0,
}) => {
  const isTalent = type === 'talent';
  const hasChildren = childCount > 0;

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className="border-t-4 border-t-destructive sm:max-w-xs">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2.5">
            <TriangleAlert className="h-5 w-5 text-destructive" />
            Slett {isTalent ? 'talent' : 'kategori'}
          </DialogTitle>
        </DialogHeader>

        <div>
          <p className="text-sm text-foreground mb-2">Er du sikker på at du vil slette</p>
          <div className="bg-muted rounded-md p-3 mb-2">
            <p className="text-sm font-semibold">{itemName}</p>
            {kategoriNavn && (
              <p className="text-xs text-muted-foreground mt-0.5">{kategoriNavn}</p>
            )}
            {hasChildren && (
              <p className="text-xs font-semibold text-yellow-600 mt-1">
                inkludert {childCount} sub-element{childCount > 1 ? 'er' : ''}
              </p>
            )}
          </div>
          <p className="text-xs text-destructive">Denne handlingen kan ikke angres.</p>
        </div>

        <DialogFooter>
          <Button variant="ghost" onClick={onClose}>
            Avbryt
          </Button>
          <Button variant="destructive" onClick={onConfirm}>
            Slett
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmDeleteTalentDialog;
